import axios from "axios";
//https://backend-qureo-production-fab5.up.railway.app
//https://backend-qureo-production-fab5.up.railway.app
//https://backend-qureo-production-fab5.up.railway.app
const API_BASE =  "https://backend-qureo-production-fab5.up.railway.app";
const REQUEST_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS || 45000);

const api = axios.create({
  baseURL: API_BASE,
  timeout: REQUEST_TIMEOUT_MS,
  
});

api.interceptors.request.use((config) => {
  const path = config?.url || "";
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers = {
      ...(config.headers || {}),
      Authorization: `Bearer ${token}`,
    };
  }

  const shouldAttachUserId = ![
    "/api/auth/signin",
    "/api/auth/signup",
    "/api/auth/google",
    "/api/auth/me",
  ].some((authPath) => path.startsWith(authPath));

  if (!shouldAttachUserId) {
    return config;
  }

  const userId = localStorage.getItem("userId");

  if (config.data instanceof FormData) {
    if (userId) {
      config.data.append("userId", userId);
    }
    delete config.headers["Content-Type"];
  } else if (config.method === 'get' || config.method === 'delete') {
    // For GET/DELETE, add userId as query param
    if (userId) {
      config.params = { ...(config.params || {}), userId };
    }
  } else {
    // POST/PUT/PATCH — add userId to body
    if (userId) {
      config.data = { ...(config.data || {}), userId };
    }
  }

  return config;
});

export default api; 
